import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // If not logged in, redirect to login page
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // If onboarding is not completed, redirect to onboarding (except if already on it)
  if (user && (!profile || !profile.onboarding_complete) && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  // If not an admin, redirect to home
  if (profile?.role !== 'admin') {
    console.warn(`Intento de acceso no autorizado a ruta administrativa por usuario: ${user.email}`);
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};
